// Dispositivo revogado ao vivo (MON-570) pode continuar com marcador visivel no mapa
// por mais tempo que o device leva pra sumir de self.devices (mapa e lista reagem ao
// canal devicesRemoved em momentos diferentes). Clicar nesse resto visual selecionava
// um id que a store nao tem mais -- ao inves de crash silencioso ou no-op sem feedback,
// avisa o usuario e recarrega pra buscar o estado real via API.
export const notifyDeviceGoneAndReload = (toast, intl, messageId = 'deviceNoLongerAccessible') => {
  toast.warn(intl.formatMessage({id: messageId}));
  setTimeout(() => window.location.reload(), 1500);
};
